import application from "stimulus_application";
import { definitionsFromContext } from "stimulus/webpack-helpers";
import "../../global/flatpickr.css";
import "./contact_form.css";
import "./contact_form_flatpickr.css";

const context = require.context('./', true, /_controller\.js$/);
application.load(definitionsFromContext(context));
